// extracted by extract-css-chunks-webpack-plugin
module.exports = {"fixIcon":"fixIcon-2dP2E7HT","fixTopIcon":"fixTopIcon-3zIJnHjg","fixBottomIcon":"fixBottomIcon-2UisADy0"};